import { render, staticRenderFns } from "./SeeDoctorRecords.vue?vue&type=template&id=5b7b0e6a&scoped=true&"
import script from "./SeeDoctorRecords.vue?vue&type=script&lang=js&"
export * from "./SeeDoctorRecords.vue?vue&type=script&lang=js&"
import style0 from "./SeeDoctorRecords.vue?vue&type=style&index=0&id=5b7b0e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b0e6a",
  null
  
)

export default component.exports